import type { PermissionModule } from '../types/permissionsList.types';

interface PermissionPolicyBlockProps {
  modules: PermissionModule[];
}

export function PermissionPolicyBlock({ modules }: PermissionPolicyBlockProps) {
  const riskyActions = modules.flatMap((module) =>
    module.resources.flatMap((resource) =>
      resource.actions
        .filter((action) => action.risk === 'Cao' || action.risk === 'Rất cao')
        .map((action) => ({
          key: `${module.code}.${resource.code}.${action.code}`,
          moduleName: module.name,
          resourceName: resource.name,
          actionName: action.name,
          risk: action.risk,
          scopes: action.scopes,
          dependencies: action.dependencies || [],
        })),
    ),
  );

  return (
    <section className="min-w-0 overflow-hidden rounded-md border border-slate-100 bg-white p-3 shadow-sm">
      <div className="min-w-0 space-y-2 text-sm">
        <div className="min-w-0">
          <h2 className="truncate font-medium text-slate-900">Policy và phạm vi rủi ro cao</h2>
          <p className="line-clamp-2 text-slate-500">Danh sách quyền cần kiểm soát chặt theo phạm vi dữ liệu và quyền phụ thuộc.</p>
        </div>
        <div className="grid min-w-0 gap-2 lg:grid-cols-2">
          {riskyActions.slice(0, 8).map((item) => (
            <div key={item.key} className="min-w-0 rounded-md border border-rose-100 bg-rose-50 p-3">
              <div className="space-y-2 text-sm">
                <div className="flex min-w-0 items-center justify-between gap-2">
                  <p className="truncate font-medium text-rose-900">{item.moduleName} / {item.resourceName}</p>
                  <span className="shrink-0 rounded-md bg-white px-2 py-1 text-sm font-medium text-rose-700">{item.risk}</span>
                </div>
                <p className="truncate font-semibold text-slate-900">{item.actionName}</p>
                <p className="line-clamp-2 text-slate-600">Phạm vi cho phép: {item.scopes.join(', ')}</p>
                <p className="line-clamp-2 text-slate-500">
                  Phụ thuộc: {item.dependencies.length ? item.dependencies.join(', ') : 'Không có'}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
